<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" id="_idContainer005" role="doc-chapter">
<p class="pl-title">Her Cowboy Reunion</p>
<p class="pl-author">Ruth Logan Herne</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Her_Cowboy_Reunion.vue?67cf6976